module.exports = __webpack_public_path__ + "img/back_admin_dashboard_white.6d0b1213.svg";